import { render, staticRenderFns } from "./CustomerSubscriptions.vue?vue&type=template&id=1073c902"
import script from "./CustomerSubscriptions.vue?vue&type=script&lang=js"
export * from "./CustomerSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports